import script from "./ImagesBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagesBox.vue?vue&type=script&setup=true&lang=js"

import "./ImagesBox.vue?vue&type=style&index=0&id=75cdf9b7&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75cdf9b7"]])

export default __exports__